<!-- App header -->
<div class="tw-hidden md:tw-block">
    <app-header
        [clicked]="clickedOutside"
        (changeMegaMenuCondition)="changeMenuCondition($event)"
    ></app-header>
</div>
<div
    (click)="closeMegaMenuCondition()"
    class="tw-px-[5vw] md:tw-px-[4vw] tw-pt-[62px] md:tw-pt-[41px] tw-bg-gradient-to-r tw-bg-gradient tw-from-[#fffbf8] tw-to-[#F9F9F9]"
>
    <div class="tw-pb-[27px] tw-block md:tw-hidden">
        <mat-icon
            routerLink="/applications"
            class="tw-block md:tw-hidden mat-icon tw-scale-[1.8] tw-mb-[55px]"
            >chevron_left</mat-icon
        >
        <div>
            <div class="tw-text-2xl tw-font-semibold">
                {{ "COMMON.DRAFT" | translate }}
            </div>
            <div
                class="tw-text-base tw-text-caption-gray tw-font-medium tw-pb-[19px]"
            >
                {{ "DRAFT.ALL_INCOMPLETE_APPLICATIONS" | translate }}
            </div>
            <div class="tw-border-b-2"></div>
        </div>
    </div>
    <div class="tw-hidden md:tw-block">
        <application-header [activeTab]="'draft'"></application-header>
        <div class="tw-pb-10 tw-mt-3" *ngIf="drafts.length == 0 && apiResponse">
            {{ "COMMON.NO_RECORD" | translate }}
        </div>
    </div>

    <div class="tw-py-[40px]" *ngIf="drafts.length > 0">
        <div class="md:tw-ml-[10px] tw-flex tw-items-center tw-pb-[22px]">
            <input
                type="checkbox"
                class="appearance-none checked:bg-primary-blue tw-w-[24px] tw-h-[24px]"
                [(ngModel)]="selectAll"
                (input)="toggleAllCheckboxes()"
            />
            <label
                class="tw-ps-[18px] tw-pe-[34px] tw-text-[16px] tw-font-semibold tw-text-caption-gray"
                >{{ "DRAFT.SELECT_ALL" | translate }}</label
            >
            <button
                class="tw-hidden md:tw-block tw-p-[10px] delete-btn tw-rounded-full"
                *ngIf="deleteBtn && totalSelected() > 1"
                (click)="deleteDraft()"
            >
                <div class="tw-w-[24px] tw-h-[24px]">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 -960 960 960"
                        width="24"
                    >
                        <path
                            d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"
                            fill="#FF8819"
                        />
                    </svg>
                </div>
            </button>
            <button
                class="tw-p-[10px] delete-btn tw-rounded-full md:tw-hidden"
                *ngIf="deleteBtn"
                (click)="deleteDraft()"
            >
                <div class="tw-w-[24px] tw-h-[24px]">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 -960 960 960"
                        width="24"
                    >
                        <path
                            d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"
                            fill="#FF8819"
                        />
                    </svg>
                </div>
            </button>
        </div>
        <ng-container *ngFor="let draft of drafts">
            <div
                class="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-pb-[14px]"
                *ngIf="!draft.softDelete"
            >
                <div
                    class="tw-flex tw-items-center tw-basis-8/12 md:tw-basis-6/12 tw-pb-[14px]"
                >
                    <div class="tw-basis-1/12 tw-hidden md:tw-block">
                        <button
                            class="tw-p-[10px] delete-btn tw-rounded-full"
                            *ngIf="draft.selected && totalSelected() < 2"
                            (click)="deleteDraft()"
                        >
                            <div class="tw-w-[24px] tw-h-[24px]">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="24"
                                    viewBox="0 -960 960 960"
                                    width="24"
                                >
                                    <path
                                        d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"
                                        fill="#FF8819"
                                    />
                                </svg>
                            </div>
                        </button>
                    </div>

                    <input
                        type="checkbox"
                        class="appearance-none checked:bg-primary-blue tw-w-[24px] tw-h-[24px]"
                        [(ngModel)]="draft.selected"
                        (input)="toggleSelection(draft)"
                    />
                    <label class="tw-px-4 tw-text-[18px] tw-font-semibold">
                        {{
                            draft.productName
                                ? draft.productName
                                : ("DRAFT.GET_PRODUCT_RECCOMENDATIONS"
                                  | translate)
                        }}
                    </label>
                </div>
                <div class="tw-block md:tw-hidden md:tw-basis-4/12">
                    <button
                        class="tw-w-[34px] tw-h-[34px] tw-rounded-full tw-text-primary-blue tw-font-semibold tw-bg-[#DDEEF6] tw-flex tw-justify-center tw-items-center"
                        type="submit"
                        [disabled]="draft.selected"
                        [ngClass]="{
                            'tw-text-gray-600  tw-bg-gray-200': draft.selected,
                            'tw-text-primary-blue  tw-bg-[#DDEEF6]':
                                !draft.selected
                        }"
                        (click)="
                            resume(
                                draft.caseId,
                                draft.qType,
                                draft.selectedProducts,
                                draft.productName
                            )
                        "
                    >
                        <div *ngIf="!draft.selected">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="24"
                                viewBox="0 -960 960 960"
                                width="24"
                            >
                                <path
                                    d="M240-240v-480h80v480h-80Zm160 0 400-240-400-240v480Zm80-141v-198l165 99-165 99Zm0-99Z"
                                    fill="#4B6EEC"
                                />
                            </svg>
                        </div>
                        <div *ngIf="draft.selected">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="24"
                                viewBox="0 -960 960 960"
                                width="24"
                            >
                                <path
                                    d="M240-240v-480h80v480h-80Zm160 0 400-240-400-240v480Zm80-141v-198l165 99-165 99Zm0-99Z"
                                    fill="#4b5563"
                                />
                            </svg>
                        </div>
                    </button>
                </div>
                <div
                    class="tw-flex tw-items-center tw-basis-full md:tw-basis-6/12 tw-ps-8 md:tw-ps-0 tw-pt-1 md:tw-pt-0 tw-justify-start md:tw-justify-end tw-pb-[14px]"
                >
                    <div class="tw-flex tw-items-center">
                        <div
                            class="tw-text-[16px] tw-font-semibold tw-w-[280px] tw-text-caption-gray tw-text-left"
                        >
                            {{ formatDate(draft.updatedDateTime) }}
                        </div>
                        <button
                            class="tw-ml-5 tw-py-[1rem] tw-max-w-[129px] tw-max-h-[56px] tw-rounded-[16px] tw-font-semibold tw-h-full tw-hidden md:tw-flex md:tw-justify-center md:tw-item tw-w-full"
                            type="submit"
                            [disabled]="draft.selected"
                            [ngClass]="{
                                'tw-text-gray-600  tw-bg-gray-200':
                                    draft.selected,
                                'tw-text-primary-blue  tw-bg-[#DDEEF6]':
                                    !draft.selected
                            }"
                            (click)="
                                resume(
                                    draft.caseId,
                                    draft.qType,
                                    draft.selectedProducts,
                                    draft.productName
                                )
                            "
                        >
                            {{ "COMMON.RESUME" | translate }}
                        </button>
                    </div>
                </div>
                <div
                    class="tw-basis-full tw-ms-0 md:tw-ms-10 tw-pb-[18px]"
                    *ngIf="draft"
                >
                    <div
                        *ngIf="true"
                        class="tw-bg-accent-gray-dark tw-w-full tw-rounded-[24px]"
                    >
                        <div
                            class="tw-border-b-2 tw-hidden md:tw-block tw-border-solid tw-border-caption-gray tw-border-opacity-10 tw-px-0 md:tw-px-[25px] lg:tw-px-[35px] tw-py-0 md:tw-py-[13px]"
                        >
                            <div
                                class="tw-text-[14px] tw-font-semibold tw-text-caption-gray"
                            >
                                {{ "DRAFT.LAST_COMPLETED" | translate }}:
                                {{ "DRAFT.STEP" | translate }}
                                {{
                                    getStepNo(draft.qType) > 2
                                        ? getStepNo(draft.qType) - 1
                                        : getStepNo(draft.qType)
                                }}
                            </div>
                        </div>
                        <div
                            class="tw-flex tw-flex-wrap tw-items-center tw-px-0 md:tw-px-[25px] lg:tw-px-[35px] tw-py-0 md:tw-py-[13px]"
                        >
                            <div
                                class="md:tw-hidden tw-flex tw-items-center tw-justify-center tw-basis-full md:tw-basis-auto tw-px-[23px] tw-py-[12px] tw-border-b-2 tw-border-solid tw-border-caption-gray tw-border-opacity-10"
                            >
                                <button
                                    class="tw-flex tw-justify-center tw-items-center tw-bg-white tw-px-[24px] tw-mb-[2px] tw-py-[7px] tw-text-[16px] tw-font-semibold tw-rounded-full"
                                >
                                    <mat-icon
                                        class="tw-me-[10px] mat-icon tw-scale-[0.8] tw-text-caption-gray"
                                    >
                                        arrow_forward</mat-icon
                                    >
                                    {{ "DRAFT.STEP" | translate }}
                                    {{ getStepNo(draft.qType) }}
                                </button>
                            </div>
                            <div
                                class="tw-flex tw-items-center tw-basis-full md:tw-basis-auto tw-px-[23px] md:tw-px-0 tw-py-[12px] md:tw-py-0 tw-border-b-2 md:tw-border-b-0 tw-border-solid md:tw-border-none tw-border-caption-gray tw-border-opacity-5"
                            >
                                <div class="tw-block md:tw-hidden">
                                    <mat-icon
                                        class="tw-me-[14px] mat-icon tw-text-caption-gray"
                                    >
                                        subdirectory_arrow_right</mat-icon
                                    >
                                </div>

                                <div
                                    *ngIf="
                                        getStepNo(draft.qType) > 1;
                                        else else_content_1
                                    "
                                >
                                    <mat-icon
                                        class="tw-text-primary-blue tw-scale-[1.2]"
                                        fontIcon="check_circle"
                                    >
                                    </mat-icon>
                                </div>

                                <ng-template #else_content_1>
                                    <div
                                        [ngClass]="{
                                            'tw-bg-placeholder-gray':
                                                getStepNo(draft.qType) < 1,
                                            'tw-bg-accent-light tw-text-primary-orange':
                                                getStepNo(draft.qType) === 1
                                        }"
                                        class="tw-w-[28px] tw-h-[28px] tw-flex tw-justify-center tw-items-center tw-rounded-full tw-text-[18px] tw-font-semibold"
                                    >
                                        1
                                    </div>
                                </ng-template>

                                <div class="tw-ps-[13px]">
                                    <div
                                        class="tw-text-[12px] tw-text-caption-gray tw-pb-[3px]"
                                    >
                                        {{ "DRAFT.STEP" | translate }} 1
                                    </div>
                                    <div
                                        class="tw-text-[16px] tw-font-semibold"
                                    >
                                        {{ "DRAFT.FINANCING_INFO" | translate }}
                                    </div>
                                </div>
                            </div>
                            <div
                                class="tw-px-[15px] tw-text-[14px] tw-font-semibold tw-hidden md:tw-block"
                            >
                                >
                            </div>
                            <div
                                class="tw-flex tw-items-center tw-basis-full md:tw-basis-auto tw-px-[23px] md:tw-px-0 tw-py-[12px] md:tw-py-0 tw-border-b-2 md:tw-border-b-0 tw-border-solid md:tw-border-none tw-border-caption-gray tw-border-opacity-10"
                            >
                                <div class="tw-block md:tw-hidden">
                                    <mat-icon
                                        class="tw-me-[14px] mat-icon tw-text-caption-gray"
                                    >
                                        subdirectory_arrow_right</mat-icon
                                    >
                                </div>

                                <div
                                    *ngIf="
                                        getStepNo(draft.qType) > 2;
                                        else else_content_2
                                    "
                                >
                                    <mat-icon
                                        class="tw-text-primary-blue tw-scale-[1.2]"
                                        fontIcon="check_circle"
                                    >
                                    </mat-icon>
                                </div>

                                <ng-template #else_content_2>
                                    <div
                                        [ngClass]="{
                                            'tw-bg-placeholder-gray':
                                                getStepNo(draft.qType) < 2,
                                            'tw-bg-accent-light tw-text-primary-orange':
                                                getStepNo(draft.qType) === 2
                                        }"
                                        class="tw-w-[28px] tw-h-[28px] tw-flex tw-justify-center tw-items-center tw-rounded-full tw-text-[18px] tw-font-semibold"
                                    >
                                        2
                                    </div>
                                </ng-template>

                                <div class="tw-ps-[13px]">
                                    <div
                                        class="tw-text-[12px] tw-text-caption-gray tw-pb-[3px]"
                                    >
                                        {{ "DRAFT.STEP" | translate }} 2
                                    </div>
                                    <div
                                        class="tw-text-[16px] tw-font-semibold"
                                    >
                                        {{ "DRAFT.BUSINESS_INFO" | translate }}
                                    </div>
                                </div>
                            </div>
                            <div
                                class="tw-px-[15px] tw-text-[14px] tw-font-semibold tw-hidden md:tw-block"
                            >
                                >
                            </div>
                            <div
                                class="tw-flex tw-items-center tw-basis-full md:tw-basis-auto tw-px-[23px] md:tw-px-0 tw-py-[12px] md:tw-py-0 tw-border-b-2 md:tw-border-b-0 tw-border-solid md:tw-border-none tw-border-caption-gray tw-border-opacity-10"
                            >
                                <div class="tw-block md:tw-hidden">
                                    <mat-icon
                                        class="tw-me-[14px] mat-icon tw-text-caption-gray"
                                    >
                                        subdirectory_arrow_right</mat-icon
                                    >
                                </div>
                                <div
                                    *ngIf="
                                        getStepNo(draft.qType) > 3;
                                        else else_content_3
                                    "
                                >
                                    <mat-icon
                                        class="tw-text-primary-blue tw-scale-[1.2]"
                                        fontIcon="check_circle"
                                    >
                                    </mat-icon>
                                </div>

                                <ng-template #else_content_3>
                                    <div
                                        [ngClass]="{
                                            'tw-bg-placeholder-gray':
                                                getStepNo(draft.qType) < 3,
                                            'tw-bg-accent-light tw-text-primary-orange':
                                                getStepNo(draft.qType) === 3
                                        }"
                                        class="tw-w-[28px] tw-h-[28px] tw-flex tw-justify-center tw-items-center tw-rounded-full tw-text-[18px] tw-font-semibold"
                                    >
                                        3
                                    </div>
                                </ng-template>
                                <div class="tw-ps-[13px]">
                                    <div
                                        class="tw-text-[12px] tw-text-caption-gray tw-pb-[3px]"
                                    >
                                        {{ "DRAFT.STEP" | translate }} 3
                                    </div>
                                    <div
                                        class="tw-text-[16px] tw-font-semibold"
                                        *ngIf="isMatchedProductsFlow"
                                    >
                                        {{ "DRAFT.MATCHING" | translate }}
                                    </div>
                                    <div
                                        class="tw-text-[16px] tw-font-semibold"
                                        *ngIf="!isMatchedProductsFlow"
                                    >
                                        {{
                                            "DRAFT.ELIGIBILITY_CHECK"
                                                | translate
                                        }}
                                    </div>
                                </div>
                            </div>
                            <!-- upload document step -->
                            <div
                                class="tw-px-[15px] tw-text-[14px] tw-font-semibold tw-hidden md:tw-block"
                            >
                                >
                            </div>
                            <div
                                class="tw-flex tw-items-center tw-basis-full md:tw-basis-auto tw-px-[23px] md:tw-px-0 tw-py-[12px] md:tw-py-0"
                            >
                                <div class="tw-block md:tw-hidden">
                                    <mat-icon
                                        class="tw-me-[14px] mat-icon tw-text-caption-gray"
                                    >
                                        subdirectory_arrow_right</mat-icon
                                    >
                                </div>
                                <div
                                    *ngIf="
                                        getStepNo(draft.qType) > 4;
                                        else else_content_4
                                    "
                                >
                                    <mat-icon
                                        class="tw-text-primary-blue tw-scale-[1.2]"
                                        fontIcon="check_circle"
                                    >
                                    </mat-icon>
                                </div>

                                <ng-template #else_content_4>
                                    <div
                                        [ngClass]="{
                                            'tw-bg-placeholder-gray':
                                                getStepNo(draft.qType) < 4,
                                            'tw-bg-accent-light tw-text-primary-orange':
                                                getStepNo(draft.qType) === 4
                                        }"
                                        class="tw-w-[28px] tw-h-[28px] tw-flex tw-justify-center tw-items-center tw-rounded-full tw-text-[18px] tw-font-semibold"
                                    >
                                        4
                                    </div>
                                </ng-template>
                                <div class="tw-ps-[13px]">
                                    <div
                                        class="tw-text-[12px] tw-text-caption-gray tw-pb-[3px]"
                                    >
                                        {{ "DRAFT.STEP" | translate }} 4
                                    </div>
                                    <div
                                        class="tw-text-[16px] tw-font-semibold"
                                    >
                                        {{
                                            "COMMON.UPLOAD_DOCUMENT" | translate
                                        }}
                                    </div>
                                </div>
                            </div>
                            <!-- submit step -->
                            <div
                                class="tw-px-[15px] tw-text-[14px] tw-font-semibold tw-hidden md:tw-block"
                            >
                                >
                            </div>
                            <div
                                class="tw-flex tw-items-center tw-basis-full md:tw-basis-auto tw-px-[23px] md:tw-px-0 tw-py-[12px] md:tw-py-0 tw-border-b-2 md:tw-border-b-0 tw-border-solid md:tw-border-none tw-border-caption-gray tw-border-opacity-10"
                            >
                                <div class="tw-block md:tw-hidden">
                                    <mat-icon
                                        class="tw-me-[14px] mat-icon tw-text-caption-gray"
                                    >
                                        subdirectory_arrow_right</mat-icon
                                    >
                                </div>

                                <div
                                    *ngIf="
                                        getStepNo(draft.qType) > 5;
                                        else else_content_5
                                    "
                                >
                                    <mat-icon
                                        class="tw-text-primary-blue tw-scale-[1.2]"
                                        fontIcon="check_circle"
                                    >
                                    </mat-icon>
                                </div>

                                <ng-template #else_content_5>
                                    <div
                                        [ngClass]="{
                                            'tw-bg-placeholder-gray':
                                                getStepNo(draft.qType) < 5,
                                            'tw-bg-accent-light tw-text-primary-orange':
                                                getStepNo(draft.qType) === 5
                                        }"
                                        class="tw-w-[28px] tw-h-[28px] tw-flex tw-justify-center tw-items-center tw-rounded-full tw-text-[18px] tw-font-semibold"
                                    >
                                        5
                                    </div>
                                </ng-template>

                                <div class="tw-ps-[13px]">
                                    <div
                                        class="tw-text-[12px] tw-text-caption-gray tw-pb-[3px]"
                                    >
                                        {{ "DRAFT.STEP" | translate }} 5
                                    </div>
                                    <div
                                        class="tw-text-[16px] tw-font-semibold"
                                    >
                                        {{ "COMMON.SUBMIT" | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<div
    (click)="closeMegaMenuCondition()"
    class="tw-absolute tw-top-5 md:tw-top-[300px] tw-left-0 tw-flex tw-justify-center tw-w-full"
    *ngIf="deleteDraftMsg"
>
    <div
        class="md:tw-flex md:tw-items-center tw-px-8 tw-py-5 tw-rounded-2xl md:tw-rounded-full md:tw-text-center tw-z-50 tw-bg-[#E0F4FF] tw-text-sm md:tw-text-base tw-text-primary-blue tw-font-semibold"
    >
        <div class="tw-hidden md:tw-block">
            <mat-icon class="tw-me-3 mat-icon">check</mat-icon>
        </div>
        <div
            class="tw-text-[10px] tw-opacity-30 tw-text-primary-blue-dark tw-font-medium tw-pb-2 tw-block md:tw-hidden"
        >
            Successful
        </div>
        {{ "DRAFT.DRAFT_DELETE" | translate }}
    </div>
</div>

<app-footer (click)="closeMegaMenuCondition()"></app-footer>
<app-loader [showLoader]="!apiResponse"></app-loader>
